import {
    Checkbox,
    Typography,
    TextField,
    makeStyles,
    FormControlLabel,
  } from "@material-ui/core";
  import { Autocomplete } from "@material-ui/lab";
  import { classes as workerStyles } from "../AddWorkerStyles";
  import React, { useEffect, useState } from "react";
  import { getLocationForCountry } from "services/bulkUpload";
  import { Controller, useFormContext } from "react-hook-form";
  import { isEmptyObject } from "utils";
  import { useTranslation } from "react-i18next";
  import { properCase } from "utils";
  import {
    getWorkerIMTimeRole,
  } from "services/workerSchedule";
  
  const useStyles = makeStyles((theme) => workerStyles(theme));
  
  const ImtRoleAccess = ({
    setIsIMtimeWorker,
    selectedWorker,
    manager,
    setIMtimeValid,
    initialValue,
  }) => {
    const classes = useStyles();
    const { control, setValue, getValues, errors, clearErrors } =
      useFormContext();
      const [imTimeRole, setImTimeRole] = useState(null);
      const [isActiveTicked, setIsActiveTicked] = useState(true);
      const [isScannerOnly, setIsScannerOnly] = useState(false);
      const [isScannerDisabled, setIsScannerDisabled] = useState(false);
      const [loggedInWorkerIMTimeRole, setLoggedInWorkerIMTimeRole] = useState(null);
      const { t, i18n } = useTranslation();
      const [imTimeRoles, setImTimeRoles] = useState([  "Super User",
       "Supervisor",
       "Worker",
      "Support" ]);      
  useEffect(()=>{
    getWorkerIMTimeRole(manager?.workerId)
          .then((data) => {
            console.log("loggedIn worker imtRole", data);
            setLoggedInWorkerIMTimeRole(data)
      });
  },[])      
  
      useEffect(() => {
        if (!isEmptyObject(initialValue)) {
          setValue("isIMTimeActive", initialValue.isActive);
          setValue("imTimeRole", initialValue.role);
          setIsActiveTicked(initialValue?.isActive);
          setImTimeRole(initialValue?.role);
          setIsScannerOnly(initialValue?.isScannerOnly);
          setValue('isScannerOnly',initialValue?.isScannerOnly?initialValue?.isScannerOnly:false);
        }else{
          // if selected worker does not have timeRole sub collection
          if(selectedWorker){

            if(selectedWorker.worker?.isActiveWorker){
              setIsActiveTicked(selectedWorker.worker?.isActiveWorker);
              setValue("isIMTimeActive", true);
            } 
            else {
              setValue("isIMTimeActive", false);
              setIsActiveTicked(false);
            }
            if(selectedWorker.worker?.isApprover){
              setValue("imTimeRole", 'Supervisor');
              setImTimeRole('Supervisor');
            }
            else if(selectedWorker.worker?.isApprover === false) {
              setValue("imTimeRole", 'Worker');
              setImTimeRole('Worker');
            }
          }
        }

        if(loggedInWorkerIMTimeRole !=null){
          if(!isEmptyObject(loggedInWorkerIMTimeRole)){
            let filteredRoles =[];
            filteredRoles.push(...imTimeRoles);
              if(selectedWorker && selectedWorker.worker?.isManager){
                filteredRoles = filteredRoles.filter((record)=>{
                  return record!='Worker'
                });
            }
            if(loggedInWorkerIMTimeRole?.role ==='Super User' ||
            loggedInWorkerIMTimeRole?.role ==='Supervisor'){
               filteredRoles = filteredRoles.filter((record)=>{
                return record!='Super User'
              });
            }
            if(loggedInWorkerIMTimeRole?.role ==='Support' ||
              loggedInWorkerIMTimeRole?.role ==='Supervisor'){
                 filteredRoles = filteredRoles.filter((record)=>{
                  return record!='Support'
                });
              }
            setImTimeRoles(filteredRoles)
          }else{
            // if logged In user has no timeRole subcollection
            let filteredRoles=[];
            filteredRoles.push(...imTimeRoles);
            filteredRoles = filteredRoles.filter((record)=>{
              return record!='Super User'
            });
            
            if(selectedWorker && selectedWorker.worker?.isManager){
              filteredRoles = filteredRoles.filter((record)=>{
                return record!='Worker'
              });
            }
            setImTimeRoles(filteredRoles)
          }
        }
      
      }, [initialValue, loggedInWorkerIMTimeRole]);

      useEffect(() => {
        if (getValues("isIMTimeActive") || initialValue?.isActive) {
            setIsIMtimeWorker(true);
        } else {
          setIsIMtimeWorker(false);
        }
      }, [isActiveTicked]);
      useEffect(() => {
        if (getValues("isIMTimeActive")) {
          if (getValues("imTimeRole")?.length === 0 ||
            getValues("imTimeRole") === null) {
              setIMtimeValid(false);
              setIsScannerOnly(false);
              setValue('isScannerOnly', false)
              setIsScannerDisabled(true);
          } else{ 
            setIMtimeValid(true)
            if(getValues("imTimeRole") !== "Worker" ){
              setIsScannerOnly(false);
              setValue('isScannerOnly', false)
              setIsScannerDisabled(true);
            }else{
              setIsScannerDisabled(false);
            }
          };
        } else {
          setIMtimeValid(true);
          setIsScannerOnly(false);
          setValue('isScannerOnly', false)
          setIsScannerDisabled(true);
        }
      }, [
        getValues("isIMTimeActive"),
        getValues("imTimeRole"),
      ]);
    
     
  return (
    <>

<Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
        {t("other.lblImTimeUserAccess")}
      </Typography>

      <FormControlLabel
        control={
          <Controller
            name="isIMTimeActive"
            control={control}
            defaultValue={isActiveTicked}
            render={(props) => (
              <>
                <Checkbox
                  {...props}
                  checked={props.value}
                  onChange={(e) => {
                    setIsActiveTicked(e.target.checked);
                    props.onChange(e.target.checked);
                  }}
                  color="primary"
                  style={{ paddingLeft: 0 }}
                  inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblEnableImTimeAccess")}
      />

<Controller
        name="imTimeRole"
        control={control}
        defaultValue="Worker"
        disabled={!isActiveTicked}
        rules={isActiveTicked ? { required: "Role cannot be blank" } : false}
        render={(props) => (
          <Autocomplete
            size="small"
            style={{ marginTop: 20, marginBottom: 20 }}
            options={imTimeRoles}
            value={props.value}
            disableClearable
            getOptionLabel={(option) => option}
            //getOptionLabel={(option) => t("other.lbl"+option.split(" ").join(""))}
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="imTimeRole"
                name="imTimeRole"
                 label={properCase( props.value ? t( "other.lblRole") : t( "other.lblSelectImTimeRole" ))}
                required={getValues("isIMTimeActive")}
                error={
                  Boolean(errors.imTimeRole)
                }
                helperText={errors.imTimeRole?.message}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />

<FormControlLabel
        control={
          <Controller
            name="isScannerOnly"
            control={control}
            defaultValue={isScannerOnly}
            render={(props) => (
              <>
                <Checkbox
                  {...props}
                  disabled={isScannerDisabled}
                  checked={props.value}
                  onChange={(e) => { 
                    setIsScannerOnly(e.target.checked);
                    props.onChange(e.target.checked);
                  }}
                  color="primary"
                  style={{ paddingLeft: 0 }}
                  inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblEnableScannerOnly")}
      />
     </>
  );




  };
  
  export default ImtRoleAccess;
  